// CreatePdf.jsx
import React from 'react'
import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  Font,
} from '@react-pdf/renderer'
import NotoSansJP from './fonts/NotoSansJP-Regular.ttf' // フォントファイルのパス
import { formatDateJpn } from '../../functions/utils/formatting'

// フォントを登録
Font.register({
  family: 'NotoSansJP',
  src: NotoSansJP,
  fontStyle: 'normal',
  fontWeight: 'normal',
})
// テキストを指定長で改行するヘルパー
const wrapText = (text, maxLength) => {
  if (!text) return ''

  const result = []
  for (let i = 0; i < text.length; i += maxLength) {
    result.push(text.slice(i, i + maxLength))
  }

  return result.join('\n')
}
const styles = StyleSheet.create({
  page: {
    fontFamily: 'NotoSansJP',
    padding: '10px 30px',
    flexDirection: 'column',
  },
  title: {
    fontSize: 18,
    fontWeight: 'bold',
    textAlign: 'center',
    margin: 20,
  },
  section: {
    margin: 10,
    padding: 10,
    fontSize: 12,
    borderBottom: 1,
    borderBottomColor: '#000',
  },
  table: {
    display: 'table',
    width: 'auto',
    borderStyle: 'solid',
    borderWidth: 1,
    borderRightWidth: 0,
    borderBottomWidth: 0,
  },
  tableRow: {
    flexDirection: 'row',
    width: '100%',
    minHeight: '36px', // 最小高さを設定
  },
  tableColHeader: {
    width: '20%',
    borderStyle: 'solid',
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    backgroundColor: '#f0f0f0',
    textAlign: 'center',
    padding: 3,
  },
  HeaderOrder: {
    width: '5%',
    borderStyle: 'solid',
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    backgroundColor: '#f0f0f0',
    textAlign: 'center',
    padding: 3,
  },
  HeaderKind: {
    width: '32%',
    borderStyle: 'solid',
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    backgroundColor: '#f0f0f0',
    textAlign: 'center',
    padding: 3,
  },
  HeaderMaker: {
    width: '20%',
    borderStyle: 'solid',
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    backgroundColor: '#f0f0f0',
    textAlign: 'center',
    padding: 3,
  },
  HeaderHinban: {
    width: '20%',
    borderStyle: 'solid',
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    backgroundColor: '#f0f0f0',
    textAlign: 'center',
    padding: 3,
  },
  HeaderSize: {
    width: '12%',
    borderStyle: 'solid',
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    backgroundColor: '#f0f0f0',
    textAlign: 'center',
    padding: 3,
  },
  HeaderEmb: {
    width: '16%',
    borderStyle: 'solid',
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    backgroundColor: '#f0f0f0',
    textAlign: 'center',
    padding: 3,
  },
  HeaderQuantity: {
    width: '4%',
    borderStyle: 'solid',
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    backgroundColor: '#f0f0f0',
    textAlign: 'center',
    padding: 3,
  },
  HeaderPrice: {
    width: '6%',
    borderStyle: 'solid',
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    backgroundColor: '#f0f0f0',
    textAlign: 'center',
    padding: 3,
  },
  HeaderTotalPrice: {
    width: '8%',
    borderStyle: 'solid',
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    backgroundColor: '#f0f0f0',
    textAlign: 'center',
    padding: 3,
  },
  HeaderRemarks: {
    width: '10%',
    borderStyle: 'solid',
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    backgroundColor: '#f0f0f0',
    textAlign: 'center',
    padding: 3,
  },
  HeaderDept: {
    width: '9%',
    borderStyle: 'solid',
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    backgroundColor: '#f0f0f0',
    textAlign: 'center',
    padding: 3,
  },
  HeaderBilling: {
    width: '8%',
    borderStyle: 'solid',
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    backgroundColor: '#f0f0f0',
    textAlign: 'center',
    padding: 3,
  },
  tableColHeaderWide: {
    width: '100%',
    borderStyle: 'solid',
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    backgroundColor: '#f0f0f0',
    textAlign: 'center',
    padding: 3,
  },
  //ヘッダのセルのスタイル
  tableCellHeader: {
    fontSize: 8,
    fontWeight: 'bold',
  },
  //2段分の高さ
  doubleHeight: {
    height: '37px',
  },
  tableCol: {
    borderStyle: 'solid',
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    padding: '3px 3px',
    fontSize: 10,
    minHeight: '36px', // 固定heightをminHeightに変更
    display: 'flex',
    alignItems: 'flex-start', // 上揃え
    justifyContent: 'center',
  },
  tableCell: {
    width: '10%',
    fontSize: 9,
    minHeight: '18px', // 固定heightをminHeightに変更
    padding: '3px 1px',
  },
  tableCellFooter: {
    width: '10%',
    fontSize: 9,
    height: '18px',
    padding: '1px 1px 0',
    overflow: 'hidden',
  },
  CellOrder: {
    width: '5%',
    fontSize: 9,
    padding: '3px 2px',
    textAlign: 'right',
  },
  CellKind: {
    width: '16%',
    fontSize: 9,
    padding: '3px 2px',
    textAlign: 'left',
    // overflow: 'hidden' を削除して折り返しを可能にする
  },
  CellMaker: {
    width: '10%',
    fontSize: 9,
    padding: '3px 1px',
  },
  CellHinban: {
    width: '10%',
    fontSize: 9,
    padding: '3px 1px',
  },
  CellSize: {
    width: '6%',
    fontSize: 9,
    padding: '3px 1px',
  },
  CellEmb: {
    width: '8%',
    fontSize: 8,
    padding: '3px 1px',
  },
  CellQuantity: {
    width: '4%',
    fontSize: 9,
    padding: '3px 2px',
    textAlign: 'right',
  },
  CellPrice: {
    width: '6%',
    fontSize: 9,
    padding: '3px 2px',
    textAlign: 'right',
  },
  CellTotalPrice: {
    width: '8%',
    fontSize: 9,
    padding: '3px 2px',
    textAlign: 'right',
  },
  CellRemarks: {
    width: '10%',
    fontSize: 8,
    padding: '3px 1px',
  },
  CellDept: {
    width: '9%',
    fontSize: 8,
    padding: '3px 1px',
    textAlign: 'left',
    // overflow: 'hidden' を削除
    // display: 'inline-block' を削除
  },
  CellBilling: {
    width: '8%',
    fontSize: 8,
    padding: '3px 1px',
    textAlign: 'left',
    // overflow: 'hidden' を削除
    // display: 'inline-block' を削除
  },
  sectionHeader: {
    fontSize: 14,
    fontWeight: 'bold',
  },
  sectionText: {
    fontSize: 12,
    margin: ' 1px 4px',
  },
  textLeft: {
    textAlign: 'left',
  },
  textRight: {
    textAlign: 'right',
  },
  row: {
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  itemSection: {
    flexDirection: 'column',
    width: '50%',
  },
  itemRow: {
    flexDirection: 'row',
    width: '100%',
  },
  tableRowFooter: {
    flexDirection: 'row',
    width: '100%',
  },
  tableColFooterWide: {
    width: '90%',
    borderStyle: 'solid',
    borderWidth: 1,
    borderTopWidth: 0,
    padding: '0 3px',
    fontSize: 10,
    height: '18px',
  },
  tableColFooter: {
    borderStyle: 'solid',
    borderWidth: 1,
    borderTopWidth: 0,
    borderLeftWidth: 0,
    textAlign: 'center',
    padding: '0 3px',
    fontSize: 10,
    height: '18px',
  },
})
const sleep = (time) => new Promise((resolve) => setTimeout(resolve, time))
const OrderPDF = ({ orderForms }) => {
  return (
    <Document>
      {orderForms.map((form, pageIndex) => {
        return (
          <Page
            key={pageIndex}
            size="A4"
            orientation="landscape"
            style={styles.page}
          >
            <Text style={styles.title}>注文書／発送依頼書</Text>
            <View style={styles.section}>
              <Text style={[styles.sectionHeader, styles.textLeft]}>
                {`${form.shop_name}　御中`}
              </Text>
              <Text
                style={[styles.sectionText, styles.textRight]}
              >{`発注日: ${formatDateJpn(new Date())}`}</Text>
              <Text
                style={[styles.sectionText, styles.textLeft]}
              >{`FAX: ${form.shop_fax}`}</Text>
              <View style={styles.row}>
                <Text style={styles.sectionText}>
                  下記の通り発注いたしますので、何卒よろしくお願い申し上げます。
                </Text>
                <Text
                  style={[styles.sectionText, styles.textRight]}
                >{`会社名: ${'森松工業株式会社'}`}</Text>
              </View>
              <Text
                style={[styles.sectionText, styles.textRight]}
              >{`事業所名: ${form.orders[0].delivery_office_name}`}</Text>
              <Text
                style={[styles.sectionText, styles.textRight]}
              >{`住所: ${form.orders[0].delivery_office_address_main}`}</Text>
              <Text
                style={[styles.sectionText, styles.textRight]}
              >{` ${form.orders[0].delivery_office_address_sub}`}</Text>
              <Text
                style={[styles.sectionText, styles.textRight]}
              >{`電話番号: ${form.orders[0].delivery_office_tell}`}</Text>
              <Text
                style={[styles.sectionText, styles.textRight]}
              >{`担当者氏名: ${form.orders[0].order_user_name}`}</Text>
            </View>
            <View style={styles.table}>
              <View style={styles.tableRow}>
                <Text
                  style={[
                    styles.HeaderOrder,
                    styles.tableCellHeader,
                    styles.doubleHeight,
                  ]}
                >
                  発注番号
                </Text>
                <View style={styles.itemSection}>
                  <Text
                    style={[styles.tableColHeaderWide, styles.tableCellHeader]}
                  >
                    商品
                  </Text>
                  <View style={styles.itemRow}>
                    <Text style={[styles.HeaderKind, styles.tableCellHeader]}>
                      種類
                    </Text>
                    <Text style={[styles.HeaderMaker, styles.tableCellHeader]}>
                      メーカー
                    </Text>
                    <Text style={[styles.HeaderHinban, styles.tableCellHeader]}>
                      品番
                    </Text>
                    <Text style={[styles.HeaderSize, styles.tableCellHeader]}>
                      サイズ
                    </Text>
                    <Text style={[styles.HeaderEmb, styles.tableCellHeader]}>
                      刺繍
                    </Text>
                  </View>
                </View>
                <Text
                  style={[
                    styles.HeaderQuantity,
                    styles.tableCellHeader,
                    styles.doubleHeight,
                  ]}
                >
                  数量
                </Text>
                <Text
                  style={[
                    styles.HeaderPrice,
                    styles.tableCellHeader,
                    styles.doubleHeight,
                  ]}
                >
                  単価
                </Text>
                <Text
                  style={[
                    styles.HeaderTotalPrice,
                    styles.tableCellHeader,
                    styles.doubleHeight,
                  ]}
                >
                  金額（税抜）
                </Text>
                <Text
                  style={[
                    styles.HeaderRemarks,
                    styles.tableCellHeader,
                    styles.doubleHeight,
                  ]}
                >
                  備考
                </Text>
                <Text
                  style={[
                    styles.HeaderDept,
                    styles.tableCellHeader,
                    styles.doubleHeight,
                  ]}
                >
                  部署名
                </Text>
                <Text
                  style={[
                    styles.HeaderBilling,
                    styles.tableCellHeader,
                    styles.doubleHeight,
                  ]}
                >
                  依頼者
                </Text>
              </View>
              {form.orders.map((order, index) => {
                // const kindText =
                //   order.name.length > 15 ? wrapText(order.name, 20) : order.name
                // const kindText = order.name
                // 部署名のフォントサイズ調整
                const deptText = wrapText(order.delivery_department || '', 8)
                const deptLen = (order.delivery_department || '').length
                const deptFontSize = deptLen >= 9 ? 7 : 8
                // 依頼者のテキストとフォントサイズ調整
                // const billingText =
                //   order.billing_user_name || order.billing_company_name || ''
                const billingText = wrapText(
                  order.billing_user_name || order.billing_company_name || '',
                  8 // 依頼者は10文字で改行
                )
                const billLen = billingText.length
                const billingFontSize = billLen >= 9 ? 7 : 8
                //種類のフォントサイズ調整
                const kindText = wrapText(order.name, 20) // 種類は20文字で改行
                const kindLen = kindText.length
                const kindFontSize = kindLen >= 15 ? 6 : kindLen > 10 ? 8 : 9
                // 部署は12文字で改行
                //備考のテキストとフォン路サイズ調整
                const remarksText = wrapText(order.remarks, 11) // 備考は20文字で改行
                const remarksLen = remarksText.length
                const remarksFontSize = remarksLen >= 15 ? 7 : 8

                return (
                  <View style={styles.tableRow} key={index}>
                    <Text style={[styles.tableCol, styles.CellOrder]}>
                      {order.order_number}
                    </Text>
                    <Text
                      style={[
                        styles.tableCol,
                        styles.CellKind,
                        { flexWrap: 'wrap' },
                        { fontSize: kindFontSize },
                      ]}
                    >
                      {kindText}
                    </Text>

                    <Text style={[styles.tableCol, styles.CellMaker]}>
                      {order.maker_name}
                    </Text>
                    <Text style={[styles.tableCol, styles.CellHinban]}>
                      {order.idout}
                    </Text>
                    <Text style={[styles.tableCol, styles.CellSize]}>
                      {order.size}
                    </Text>
                    <Text style={[styles.tableCol, styles.CellEmb]}>
                      {order.embroidery === '有' ? '企業名' : ''}
                    </Text>
                    <Text style={[styles.tableCol, styles.CellQuantity]}>
                      {order.quantity}
                    </Text>
                    <Text style={[styles.tableCol, styles.CellPrice]}>
                      {order.price.toLocaleString()}
                    </Text>
                    <Text style={[styles.tableCol, styles.CellTotalPrice]}>
                      {order.totalPrice.toLocaleString()}
                    </Text>
                    <Text
                      style={[
                        styles.tableCol,
                        styles.CellRemarks,
                        { flexWrap: 'wrap' },
                        { fontSize: remarksFontSize },
                      ]}
                    >
                      {remarksText}
                    </Text>
                    <Text
                      style={[
                        styles.tableCol,
                        styles.CellDept,
                        { fontSize: deptFontSize },
                        { flexWrap: 'wrap' },
                      ]}
                    >
                      {deptText}
                    </Text>
                    <Text
                      style={[
                        styles.tableCol,
                        styles.CellBilling,
                        { fontSize: billingFontSize },
                        { flexWrap: 'wrap' },
                      ]}
                    >
                      {billingText}
                    </Text>
                  </View>
                )
              })}
            </View>
            <View style={styles.tableRowFooter}>
              <Text style={styles.tableColFooterWide}></Text>
              <Text
                style={[styles.tableColFooter, styles.tableCellFooter]}
              >{`¥${form.totalPrice.toLocaleString()}`}</Text>
            </View>
          </Page>
        )
      })}
    </Document>
  )
}

export default OrderPDF
